import riveWasmUrl from '@rive-app/canvas/rive.wasm';
import {RuntimeLoader} from 'rive-react';

RuntimeLoader.setWasmUrl(riveWasmUrl)
// fetch(riveWasmUrl, { mode: 'cors', credentials: 'omit' }).catch(() => {})

// export default riveWasmUrl